"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const BehaviorModelGroupConfirmationModal = ({ previousGroupName, newGroupName, savePosition, setShowModal }) => {
    return (react_1.default.createElement(Modal_1.default, { onClose: () => setShowModal(false), minWidth: 400, customClass: "w-[400px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Edit New Position'), onClose: () => setShowModal(false) }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", { className: "typography-paragraph text-n-800 px-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('This employee will be transferred from behavior model group [previousGroupName] to [newGroupName]. Do you still want to continue?')
                .replace('[previousGroupName]', previousGroupName)
                .replace('[newGroupName]', newGroupName))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Save'),
                onClick: () => savePosition()
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: () => setShowModal(false)
            }, useBorder: false })));
};
exports.default = BehaviorModelGroupConfirmationModal;
